export default __webpack_public_path__ + "static/media/05.575f240c.jpg";